<template>
  <b-card>
    <b-form @submit.prevent="updatePodcast">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Title *" label-for="title">
            <b-form-input id="title" v-model="form.title" required />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Label" label-for="label">
            <b-form-input id="label" v-model="form.label" />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="YouTube Link" label-for="youtube_link">
            <b-form-input id="youtube_link" v-model="form.youtube_link" />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Description" label-for="description">
            <b-form-textarea id="description" v-model="form.description" rows="4" />
          </b-form-group>
        </b-col>
        
        <b-col class="d-flex justify-content-end">
          <b-button type="button" class="mr-1" variant="light" @click="$router.back()">Cancel</b-button>
          <b-button type="submit" :disabled="isLoading" variant="primary">Save</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BCard, BFormInput, BButton, BForm, BFormTextarea,
} from 'bootstrap-vue'
import axios from 'axios'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BFormInput,
    BFormTextarea,
    BButton,
    BForm,
  },

  data() {
    return {
      isLoading: false,
      originalData: {},
      token: '',
      form: {
        title: '',
        description: '',
        label: '',
        youtube_link: '',
      },
    }
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },

  mounted() {
    this.fetchPodcastDetail()
  },

  methods: {
    fetchPodcastDetail() {
      const podcastId = this.$route.params.id
      axios
        .get(`${process.env.VUE_APP_API_HELPER_URL}/podcast/${podcastId}`, {
          headers: {
            Authorization: this.token,
            Accept: 'application/json',
          },
        })
        .then((res) => {
          const data = res.data.data
          this.form = { ...data }
          this.originalData = { ...data }
        })
        .catch((err) => {
          console.error('error take data :', err.response?.data || err.message)
        })
    },

    updatePodcast() {
      this.isLoading = true
      const podcastId = this.$route.params.id
      const payload = {}
      for (const key in this.form) {
        if (this.form[key] !== this.originalData[key]) {
          payload[key] = this.form[key]
        }
      }

      if (Object.keys(payload).length === 0) {
        alert('Tidak ada perubahan yang dilakukan.')
        this.isLoading = false
        return
      }

      axios
        .put(`${process.env.VUE_APP_API_HELPER_URL}/podcast/${podcastId}`, payload, {
          headers: {
            Authorization: this.token,
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          this.$router.push({ name: 'admin-podcast' })
        })
        .catch((err) => {
          console.error('Error update:', err.response?.data || err.message)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
